var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.9697C16.8252 20.9697 20.8154 16.9795 20.8154 12.1543C20.8154 7.32031 16.8252 3.33887 11.9912 3.33887C7.16602 3.33887 3.18457 7.32031 3.18457 12.1543C3.18457 16.9795 7.1748 20.9697 12 20.9697ZM12 19.8271C7.74609 19.8271 4.32715 16.3994 4.32715 12.1543C4.32715 7.90039 7.74609 4.47266 11.9912 4.47266C16.2451 4.47266 19.6729 7.90039 19.6816 12.1543C19.6816 16.3994 16.2539 19.8271 12 19.8271ZM7.21875 13.0156H11.9912C12.2725 13.0156 12.4834 12.8047 12.4834 12.5322V6.37109C12.4834 6.09863 12.2725 5.89648 11.9912 5.89648C11.7275 5.89648 11.5166 6.09863 11.5166 6.37109V12.0576H7.21875C6.94629 12.0576 6.74414 12.2686 6.74414 12.5322C6.74414 12.8047 6.94629 13.0156 7.21875 13.0156Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.3653130dabe07ee33c81a4ed77e9775f.svg";
export { ForwardRef as ReactComponent };